import BaseApi from "./baseAPI";

class UserAPI extends BaseApi{
    get entity() {
      return {
        route: '/user',
        name: null
      }
    }

    getCourses(){
        return new Promise((resolve, reject) => {
          return this.request.get(`${this.entity.route}/courses`)
            .then(response =>  resolve(this.responseWrapper(response)))
            .catch(error => reject(this.errorWrapper(error)))
        })
    }

    getAllCurrentCourses(){
      return new Promise((resolve, reject) => {
        return this.request.get(`/current_courses`)
          .then(response =>  resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
      })
    }

    profile(id){
      return new Promise((resolve, reject) => {
        return this.request.get(`/profile/${id}`)
          .then(response =>  resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
      })
    }

    updateProfileInfo(data){
      return new Promise((resolve, reject) => {
        return this.request.put(`/profile`, data)
          .then(response =>  resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
      })
    }

    updateProfilePicture(data){
      return new Promise((resolve, reject) => {
        return this.request.post(`/profile/change-image`, data)
          .then(response =>  resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
      })
    }

    updatePassword(data){
      return new Promise((resolve, reject) => {
        return this.request.put(`/profile/change-password`, data)
          .then(response =>  resolve(this.responseWrapper(response)))
          .catch(error => reject(this.errorWrapper(error)))
      })
    }
}

export default new UserAPI()
